var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loading === true)?_c('div',[_c('lottie',{staticClass:"imageLoader__Image",attrs:{"options":_vm.defaultOptions,"height":400,"width":400}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }